import React, { useEffect, useRef, useState } from "react";
import classNames from "classnames";
import { CellSwipeProps, CellSwipeState } from "./PropsType";
import { getTouchEvent } from "../common/Utils";

export default function CellSwipe(props: CellSwipeProps) {
  const {
    className,
    children,
    leftSlot,
    rightSlot,
    prefixCls = "bm-CellSwipe",
    to,
  } = props;
  const isDragging = useRef(false);
  const pageX = useRef(0);
  const wrapperStyle = useRef({
    transitionDuration: "",
  });
  const styleClass = classNames(prefixCls, className);
  const ComponentProp = to ? "a" : "div";

  const touchEvent = getTouchEvent();

  const leftSlotElem = useRef(null);
  const rightSlotElem = useRef(null);
  const [left, setLeft] = useState(0);

  const swipeStart = (e) => {
    isDragging.current = true;
    wrapperStyle.current = {
      ...wrapperStyle.current,
      transitionDuration: "0",
    };
    pageX.current = e.changedTouches ? e.changedTouches[0].pageX : e.pageX;
    document.body.addEventListener(touchEvent.touchmove, swipeMove);
    document.body.addEventListener(touchEvent.touchend, swipeEnd);
  };

  const swipeMove = (e) => {
    if (isDragging.current) {
      setLeft((prev) => {
        let mx = prev;
        if (rightSlotElem.current && leftSlotElem.current) {
          const rightWidth = (rightSlotElem.current as HTMLDivElement)
              .offsetWidth,
            leftWidth = (leftSlotElem.current as HTMLDivElement).offsetWidth;
          const x = e.changedTouches ? e.changedTouches[0].pageX : e.pageX;
          const diffX = x - pageX.current;
          mx = prev + diffX;
          if (mx <= 0 && Math.abs(mx) >= rightWidth) {
            mx = -rightWidth;
          } else if (mx > 0 && mx >= leftWidth) {
            mx = leftWidth;
          }
          console.log(pageX.current, left, x, mx);
          pageX.current = x;
        }

        return mx;
      });
    }
  };

  const swipeEnd = () => {
    if (
      !isDragging.current ||
      !rightSlotElem.current ||
      !leftSlotElem.current
    ) {
      return;
    }
    setLeft((prev: number) => {
      if (rightSlotElem.current && leftSlotElem.current) {
        const rightWidth = (rightSlotElem.current as HTMLDivElement)
            .offsetWidth,
          leftWidth = (leftSlotElem.current as HTMLDivElement).offsetWidth;
        wrapperStyle.current = {
          ...wrapperStyle.current,
          transitionDuration: "300ms",
        };
        const halfWidth = (prev < 0 ? rightWidth : leftWidth) / 2;
        let left = 0;
        if (Math.abs(prev) > halfWidth && (prev < 0 || left > 0)) {
          left = prev < 0 ? -rightWidth : leftWidth;
        } else if (Math.abs(prev) < halfWidth) {
          left = 0;
        }
        isDragging.current = false;

        return left;
      }
      return prev;
    });
    unBindDocumentlistener();
  };

  const close = () => {
    wrapperStyle.current = {
      ...wrapperStyle.current,
      transitionDuration: "300ms",
    };
    setLeft(0);
  };

  const unBindDocumentlistener = () => {
    document.body.removeEventListener(touchEvent.touchmove, swipeMove);
    document.body.removeEventListener(touchEvent.touchend, swipeEnd);
  };

  useEffect(() => {
    return () => {
      unBindDocumentlistener();
    };
  }, []);

  return (
    <div className={styleClass}>
      <div
        className={`${prefixCls}-wrapper`}
        onTouchStart={touchEvent.mobile ? swipeStart : () => false}
        onMouseDown={!touchEvent.mobile ? swipeStart : () => false}
        style={{
          ...wrapperStyle.current,
          transform: `translate3d(${left}px, 0, 0)`,
        }}
      >
        <div className={`${prefixCls}-left`} ref={leftSlotElem}>
          {leftSlot}
        </div>
        <ComponentProp className={`${prefixCls}-content`}>
          {children}
          {left ? (
            <div className={`${prefixCls}-mask`} onClick={close} />
          ) : null}
        </ComponentProp>
        <div className={`${prefixCls}-right`} ref={rightSlotElem}>
          {rightSlot}
        </div>
      </div>
    </div>
  );
}
